<script lang="ts">
  import { dndzone, SOURCES, TRIGGERS } from "svelte-dnd-action"
  import { flip } from "svelte/animate"
  import { DotsSixVertical, ArrowsDownUp, FloppyDisk } from "phosphor-svelte"
  import { PlusCircle, Edit } from "svelte-feathers"
  import { formatCentsAsUsd } from "@util/money"
  import { post } from "@util/api"
  import { Question } from "@models/Question"
  import { Questionnaire } from "@models/Questionnaire"

  const flipDurationMs = 200
  export let items: Question[]
  export let newQuestionPath: string
  export let editQuestionnairePath: string | undefined
  export let updateOrderPath: string
  export let questionnaire: Questionnaire
  export let editTripsAllowed: boolean

  let editOn = false
  let dragDisabled = !editOn
  let dropTargetStyle = { backgroundColor: "#fffcf2", outline: "solid 1px #e5e5e5" }

  function handleConsider(event) {
    const {
      items: newItems,
      info: { source, trigger },
    } = event.detail
    items = newItems
  }

  function handleFinalize(e) {
    const {
      items: newItems,
      info: { source },
    } = e.detail
    items = newItems
  }

  function transformDraggedElement(draggedEl) {
    let draggable = draggedEl.querySelector(".draggable-item")

    draggable.classList.add("bg-white")
    draggable.classList.add("border-gray-300")
    draggable.classList.add("shadow--sm")
    draggable.classList.add("shadow--gray-400")
  }

  function startReorder(e) {
    e.preventDefault()
    editOn = true
    dragDisabled = false
  }

  async function saveOrder(e) {
    e.preventDefault()

    let orderedQuestionsIds = items.map(function (item) {
      return item.id
    })

    let response = await post(updateOrderPath, { orderedQuestionsIds })

    if (response.ok) {
      editOn = false
      dragDisabled = true
    }
  }
</script>

<section class="section-setup" data-role="questionnaire-table[{questionnaire.id}]">
  <div class="header">
    <h2>{questionnaire.name}</h2>
    <div class="flex sm:justify-end">
      {#if editOn}
        <button data-role="save-order[{questionnaire.id}]" class="button legacy-with-icon" on:click|once={saveOrder}>
          <FloppyDisk size="16" />Save
        </button>
      {:else if editTripsAllowed}
        {#if editQuestionnairePath}
          <a class="legacy-with-icon link-button-component" href={editQuestionnairePath} data-role="edit-questionnaire-link">
            <Edit size="16" />Edit
          </a>
        {/if}
        <button
          data-role="start-reordering[{questionnaire.id}]"
          class="button legacy-with-icon less-important"
          on:click|once={startReorder}>
          <ArrowsDownUp size="16" />Reorder
        </button>
        <a class="legacy-with-icon link-button-component" href={newQuestionPath} data-role="add-question-link">
          <PlusCircle size="16" />Add Question
        </a>
      {/if}
    </div>
  </div>

  <section
    class="dragndrop | stack pad-inline-4"
    use:dndzone={{ items, dragDisabled, flipDurationMs, transformDraggedElement, dropTargetStyle }}
    on:consider={handleConsider}
    on:finalize={handleFinalize}>
    {#each items as item (item.id)}
      <div
        class="draggable-row | stack border-b last:border-0"
        data-role="reorder-question[{item.id}]"
        style={dragDisabled ? "cursor: grab" : "cursor: grabbing"}
        animate:flip={{ duration: flipDurationMs }}>
        <section class="draggable-item | row gap-inline-4 pad-block-2 | text-sm">
          {#if editOn}
            <span class="text-base flex">
              <DotsSixVertical size="18" />
            </span>
          {/if}
          <span class="text-base flex">
            {#if editOn}
              {item.label}
              {#if !item.optional}<span>&nbsp;*</span>{/if}
            {:else}
              <a href={item.url} data-role="edit-question[{item.id}]">{item.label}</a>
              {#if !item.optional}<span>&nbsp;*</span>{/if}
            {/if}
          </span>
        </section>
      </div>
    {/each}
  </section>
</section>
